export const arrRandomVal = (arr) => {
  if (!arr || arr.length === 0) return null;
  return arr[Math.floor(Math.random() * arr.length)];
};

export const backgroundColors = ["#0b0f19", "#0e1422", "#0a1320"];

const QUOTES_URL = "https://type.fit/api/quotes";

const normalize = (data) =>
  data
    .filter((q) => q && q.text)
    .map(({ text, author }) => ({
      content: text,
      author: author?.replace(/,\s*type\.fit\s*$/i, "").trim() || "Unknown",
    }));

const fetchWithFallback = async (url) => {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const fetchQuotes = async () => {
  try {
    const data = await fetchWithFallback("/api/quotes");
    return normalize(data);
  } catch (devErr) {
    try {
      const proxied =
        "https://api.allorigins.win/get?url=" +
        encodeURIComponent(QUOTES_URL);
      const wrapped = await fetchWithFallback(proxied);
      const data = typeof wrapped === "string" ? JSON.parse(wrapped) : wrapped;
      return normalize(data.contents ?? data);
    } catch (err) {
      console.error("fetchQuotes failed:", err);
      return [];
    }
  }
};
